// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-layout {
  padding-bottom: 30px;
  max-height: 100% !important;
  display: flex;
  flex-direction: column;
}

.settings-layout .menu-column .menu {
  max-width: 100%;
}

.settings-layout .layout.header {
  margin-bottom: 20px;
}

.settings-layout .setting-form {
  margin-top: 30px;
}

.settings-layout .setting-form:first-child {
  margin-top: 0px;
}

.settings-layout h3 {
  margin-bottom: 20px;
}

.settings-layout h4 {
  margin-top: 15px;
}

.settings-layout > div,
.settings-layout .mobile .section-content {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  margin-bottom: 5px;
}

.settings-layout .main.grid {
  overflow-y: auto;
  padding: 0px;
}

.settings-layout .mobile .section-content {
  padding-bottom: 5px;
  /* For possible scrollbar */
  padding-right: 5px;
}

.settings-layout .mobile .section-content.about {
  margin-top: 10px;
}

.settings-layout .mobile .section-content.about .options {
  flex-shrink: 0;
}

.settings-layout .full .section-content {
  height: 100%;
  padding-bottom: 2px;
}

.settings-layout .top-menu {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.settings-layout .top-menu > .ui.dropdown,
.settings-layout .top-menu > .ui.dropdown > .caption {
  display: flex;
}

.settings-layout .top-menu > i {
  margin: 0px 5px;
}

.settings-layout .full .top-menu i {
  display: none;
}

.settings-layout .mobile .save.button {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.settings-layout .options {
  min-height: 80px;
}

.settings-layout .options > .ui.grid {
  margin: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Settings/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".settings-layout {\n  padding-bottom: 30px;\n  max-height: 100% !important;\n  display: flex;\n  flex-direction: column;\n}\n\n.settings-layout .menu-column .menu {\n  max-width: 100%;\n}\n\n.settings-layout .layout.header {\n  margin-bottom: 20px;\n}\n\n.settings-layout .setting-form {\n  margin-top: 30px;\n}\n\n.settings-layout .setting-form:first-child {\n  margin-top: 0px;\n}\n\n.settings-layout h3 {\n  margin-bottom: 20px;\n}\n\n.settings-layout h4 {\n  margin-top: 15px;\n}\n\n.settings-layout > div,\n.settings-layout .mobile .section-content {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  margin-bottom: 5px;\n}\n\n.settings-layout .main.grid {\n  overflow-y: auto;\n  padding: 0px;\n}\n\n.settings-layout .mobile .section-content {\n  padding-bottom: 5px;\n  /* For possible scrollbar */\n  padding-right: 5px;\n}\n\n.settings-layout .mobile .section-content.about {\n  margin-top: 10px;\n}\n\n.settings-layout .mobile .section-content.about .options {\n  flex-shrink: 0;\n}\n\n.settings-layout .full .section-content {\n  height: 100%;\n  padding-bottom: 2px;\n}\n\n.settings-layout .top-menu {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.settings-layout .top-menu > .ui.dropdown,\n.settings-layout .top-menu > .ui.dropdown > .caption {\n  display: flex;\n}\n\n.settings-layout .top-menu > i {\n  margin: 0px 5px;\n}\n\n.settings-layout .full .top-menu i {\n  display: none;\n}\n\n.settings-layout .mobile .save.button {\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.settings-layout .options {\n  min-height: 80px;\n}\n\n.settings-layout .options > .ui.grid {\n  margin: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
